import SocialProofCard, { SocialProofCardProps } from '@/components/_atoms/social-proof-cards/SocialProofCard';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface SocialProofQuoteCardProps extends SocialProofCardProps {
  name: string;
  title: string;
  logo?: ReactNode;
  avatar?: ReactNode;
}

const SocialProofQuoteCard: FC<SocialProofQuoteCardProps> = (props) => {
  return (
    <SocialProofCard cta={props.cta}>
      <Content>{props.children}</Content>

      <QuoteeWrapper>
        <QuoteeTextWrapper>
          <QuoteeName>{props.name}</QuoteeName>
          <QuoteeTitle>{props.title}</QuoteeTitle>
          {props.logo ? <QuoteeLogo>{props.logo}</QuoteeLogo> : null}
        </QuoteeTextWrapper>

        {props.avatar ? <QuoteeAvatar>{props.avatar}</QuoteeAvatar> : null}
      </QuoteeWrapper>
    </SocialProofCard>
  );
};

export default SocialProofQuoteCard;

// Styled Components

const QuoteeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
  }
`;

const QuoteeTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  ${mediaBreakpointUp('tablet')} {
    order: 0;
  }
`;

const QuoteeName = styled.span`
  ${customTextSize(16, 26)};
  font-weight: ${FONT_WEIGHTS.BOLD};
`;

const QuoteeTitle = styled.span`
  ${customTextSize(14, 20)};
`;

const QuoteeLogo = styled.div`
  margin-top: ${remCalc(20)};
  position: relative;
  max-width: 50%;
  max-height: ${remCalc(34)};

  img {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }
`;

const QuoteeAvatar = styled.div`
  position: relative;
  ${square(40)};
  border-radius: 100%;
  margin-bottom: ${remCalc(10)};

  ${mediaBreakpointUp('tablet')} {
    ${square(60)};
    align-self: flex-end;
  }
`;

const Content = styled.div`
  ${customTextSize(18, 27)};
  margin-top: ${remCalc(1)}; // prevent gradient from peeking on card scale
  width: 100%;
  margin-bottom: ${remCalc(20)};

  strong {
    background: linear-gradient(90deg, #ff2b73 19.41%, #ff6c35 80.07%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 34)};
  }
`;
